import Swal from "sweetalert2";
import Emitter from "./emitter";
import "./api-key-copy-dialog.scss";

const copyToClipboard = async (text) => {
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
    return;
  }
  const textarea = document.createElement("textarea");
  textarea.value = text;
  textarea.style.position = "fixed";
  textarea.style.left = "-9999px";
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand("copy");
  document.body.removeChild(textarea);
};

/**
 * Show one-time API key dialog with copy button.
 */
export const showApiKeyCopyDialog = async ({
  title,
  bodyHtml = "",
  apiKey,
  prefix,
}) => {
  const fieldId = `api-key-field-${Date.now()}`;
  const copyBtnId = `${fieldId}-copy`;

  const prefixLine = prefix
    ? `<p class="small text-muted mb-2">Prefix: <code>${prefix}</code></p>`
    : "";

  await Swal.fire({
    title,
    html: `${bodyHtml}${prefixLine}
      <div class="api-key-copy-wrap position-relative">
        <textarea id="${fieldId}" readonly class="form-control pe-5" rows="3"
          style="font-family:monospace;font-size:12px;">${apiKey}</textarea>
        <button type="button" id="${copyBtnId}" class="btn btn-sm btn-light border api-key-copy-btn"
          title="Copy to clipboard" aria-label="Copy API key">
          <i class="fa fa-copy"></i>
        </button>
      </div>`,
    icon: "success",
    confirmButtonText: "Done",
    didOpen: () => {
      const btn = document.getElementById(copyBtnId);
      const field = document.getElementById(fieldId);
      if (!btn || !field) return;

      btn.addEventListener("click", async () => {
        try {
          await copyToClipboard(apiKey);
          const icon = btn.querySelector("i");
          if (icon) {
            icon.classList.remove("fa-copy");
            icon.classList.add("fa-check", "text-success");
            setTimeout(() => {
              icon.classList.add("fa-copy");
              icon.classList.remove("fa-check", "text-success");
            }, 1500);
          }
          Emitter.emit("SHOW_NOTIFICATION", {
            message: "API key copied to clipboard",
            isError: false,
          });
        } catch {
          Emitter.emit("SHOW_NOTIFICATION", {
            message: "Could not copy — select the key and copy manually",
            isError: true,
          });
        }
      });
    },
  });
};

export default showApiKeyCopyDialog;
